import React from "react";
import { useRetrieveCurrentPlanzone } from "@planzone/view-models";
import { useLogoLoader } from "@components/logoLoader";

import { Props } from "./types";
import icon from "./icon.png";

function Logo({ className }: Props) {
  const { planzone, isRequestSuccess } = useRetrieveCurrentPlanzone();
  const logo = useLogoLoader();

  return !!logo ? (
    <img className={className} src={logo} alt="" />
  ) : (
    <img
      className={className}
      src={isRequestSuccess ? `/logos/${planzone.uuid}` : icon}
    />
  );
}

export { Logo };
